<script>
import ResetModal from "@/components/modals/prestige/ResetModal";

export default {
  name: "EternityModal",
  components: {
    ResetModal
  },
  data() {
    return {
      exitingEC: false,
      startingIP: new Decimal(),
      gainedEternityPoints: new Decimal(),
      gainedEternities: new Decimal()
    };
  },
  computed: {
    message() {
      return PlayerProgress.eternityUnlocked()
        ? `Вечность сбросит всё, за исключением Достижений, рекордов Челленджей, и всего под заголовком Основное во
          вкладке Статистики.`
        : `Вечность сбросит всё, за исключением Достижений, рекордов Челленджей, и всего под заголовком Основное во
          вкладке Статистики. Вы также получите Очко Вечности и откроете различные улучшения.`;
    },
    gainedEPOnEternity() {
      return `Вы получите ${ruQuantify("Вечность,Вечности,Вечностей", this.gainedEternities, 2)} 
      и ${ruQuantify("Очко Вечности,Очка Вечности,Очков Вечности", this.gainedEternityPoints, 2)} за Вечность.`;
    },
    startWithIP() {
      return this.startingIP.gt(0)
        ? `Вы начнёте вашу следующую Вечность с ${ruQuantify(
          "Очком Бесконечности,Очками Бесконечности,Очками Бесконечности", this.startingIP, 2)}.`
        : ``;
    },
    eternityChallenge() {
      const ec = EternityChallenge.current;
      if (ec.isFullyCompleted) {
        return `Вечный Челлендж ${ec.id} уже полностью пройден.`;
      }
      if (!Perk.studyECBulk.isBought) {
        return `Вы заработаете одно прохождение Вечного Челленджа ${ec.id}.`;
      }
      const gainedCompletions = ec.gainedCompletionStatus.gainedCompletions;
      return `Вы заработаете ${ruQuantifyInt(
        "прохождение,прохождения,прохождений", gainedCompletions)} за Вечный Челлендж ${ec.id}.`;
    }
  },
  methods: {
    update() {
      this.exitingEC = EternityChallenge.isRunning;
      this.startingIP = Currency.infinityPoints.startingValue;
      this.gainedEternityPoints = gainedEternityPoints();
      this.gainedEternities = gainedEternities();
    },
    handleYesClick() {
      animateAndEternity();
      EventHub.ui.offAll(this);
    }
  },
};
</script>

<template>
  <ResetModal
    :header="exitingEC ? 'Выполнить Вечный Челлендж' : 'Вы собираетесь закончить Вечность'"
    :message="message"
    :gained-resources="gainedEPOnEternity"
    :starting-resources="startWithIP"
    :confirm-fn="handleYesClick"
    :alternate-condition="exitingEC"
    :alternate-text="exitingEC ? eternityChallenge : undefined"
    confirm-option="eternity"
  />
</template>
